var _style, _g, _g2, _g3, _g4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExpproLogo600PxAnglaisWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 600 150.38",
    style: {
      enableBackground: "new 0 0 600 150.38"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_x3C_Group_x3E__00000117653283237197243600000017045245903062742929_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 226.19,
    y: 10.06,
    className: "st0",
    width: 5.92,
    height: 86.73
  }), /*#__PURE__*/React.createElement("rect", {
    x: 236.05,
    y: 10.06,
    className: "st0",
    width: 5.92,
    height: 86.73
  }), /*#__PURE__*/React.createElement("rect", {
    x: 245.92,
    y: 10.06,
    className: "st0",
    width: 1.97,
    height: 86.73
  }), /*#__PURE__*/React.createElement("rect", {
    x: 251.83,
    y: 10.06,
    className: "st0",
    width: 5.92,
    height: 86.73
  }), /*#__PURE__*/React.createElement("rect", {
    x: 261.69,
    y: 10.06,
    className: "st0",
    width: 1.97,
    height: 86.73
  }), /*#__PURE__*/React.createElement("rect", {
    x: 267.61,
    y: 10.06,
    className: "st0",
    width: 5.92,
    height: 86.73
  }), /*#__PURE__*/React.createElement("rect", {
    x: 277.47,
    y: 10.06,
    className: "st0",
    width: 1.97,
    height: 86.73
  }), /*#__PURE__*/React.createElement("rect", {
    x: 283.39,
    y: 10.06,
    className: "st0",
    width: 1.97,
    height: 86.73
  }), /*#__PURE__*/React.createElement("rect", {
    x: 289.31,
    y: 10.06,
    className: "st0",
    width: 5.92,
    height: 86.73
  }), /*#__PURE__*/React.createElement("rect", {
    x: 299.17,
    y: 10.06,
    className: "st0",
    width: 5.92,
    height: 86.73
  }), /*#__PURE__*/React.createElement("rect", {
    x: 309.03,
    y: 10.06,
    className: "st0",
    width: 1.98,
    height: 86.73
  }), /*#__PURE__*/React.createElement("rect", {
    x: 314.95,
    y: 10.06,
    className: "st0",
    width: 1.97,
    height: 86.73
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320.86,
    y: 10.06,
    className: "st0",
    width: 1.97,
    height: 86.73
  }), /*#__PURE__*/React.createElement("rect", {
    x: 326.78,
    y: 10.06,
    className: "st0",
    width: 1.97,
    height: 86.73
  }), /*#__PURE__*/React.createElement("rect", {
    x: 332.7,
    y: 10.06,
    className: "st0",
    width: 1.97,
    height: 86.73
  }), /*#__PURE__*/React.createElement("rect", {
    x: 338.61,
    y: 10.06,
    className: "st0",
    width: 5.92,
    height: 86.73
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M63.1,26.67H33.07v17.81h26.55v16.56H33.07v19.31H63.1v17.18H13.24V9.49H63.1V26.67z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M105.43,70.56L90.82,97.53h-22.5l26.09-44.77L67.74,9.49h23.08l16.35,26.59l14.38-26.59h22.5l-25.86,44.39 l26.9,43.64h-23.08L105.43,70.56z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M183.35,65.92h-12.29v31.6h-19.83V9.49h32.12c19.94,0,29.92,12.17,29.92,28.34 C213.27,52.38,204.11,65.92,183.35,65.92z M181.85,48.87c7.89,0,11.25-4.27,11.25-11.04s-3.36-11.04-11.25-11.04h-10.78v22.07 h10.78V48.87z"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M396.01,65.85h-12.29v31.6h-19.83V9.41h32.12c19.94,0,29.92,12.16,29.92,28.34 C425.93,52.3,416.77,65.85,396.01,65.85z M394.51,48.79c7.88,0,11.25-4.27,11.25-11.04s-3.36-11.04-11.25-11.04h-10.78v22.07 h10.78V48.79z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M465.7,9.41c19.94,0,29.92,12.41,29.92,27.72c0,11.04-5.56,21.44-18.09,25.46l18.78,34.86h-22.38L457,64.22 h-4.75v33.23h-19.83V9.41H465.7z M464.55,27.22h-12.29v21.82h12.29c7.42,0,10.9-4.14,10.9-11.04 C475.44,31.49,471.97,27.22,464.55,27.22z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M542.7,98.33c-23.08,0-41.86-18.69-41.86-45.15S519.62,8.16,542.7,8.16c23.19,0,41.63,18.56,41.63,45.02 S565.78,98.33,542.7,98.33z M542.7,78.77c12.99,0,21.45-10.16,21.45-25.58c0-15.68-8.47-25.58-21.45-25.58 c-13.22,0-21.57,9.91-21.57,25.58C521.13,68.61,529.48,78.77,542.7,78.77z"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M13.84,117.11h3.38v17.14h-3.38C13.84,134.25,13.84,117.11,13.84,117.11z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M41.57,134.87l-16.13-12.76l1.01,0.33l0.06,11.82h-3.4v-17.73h0.17l15.84,12.76l-0.75-0.19l-0.06-11.99h3.35 v17.76H41.57z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M49.76,117.11l6.61,13.45l-1.93-0.33l6.15-13.12h3.95l-9.41,17.92l-9.35-17.92H49.76z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M68.64,117.11h13.94v2.64H72.01v4.57h9.41v2.64h-9.41v4.66h10.96v2.64H68.64V117.11z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M106.2,134.87l-16.13-12.76l1.01,0.33l0.06,11.82h-3.4v-17.73h0.17l15.84,12.76L103,129.1l-0.06-11.99h3.35 v17.76L106.2,134.87L106.2,134.87z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M110.7,117.11h14.05v2.64h-5.43v14.51h-3.35v-14.51h-5.28L110.7,117.11L110.7,117.11z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M127.04,125.71c0-1.18,0.28-2.3,0.84-3.36c0.56-1.06,1.33-2,2.31-2.81c0.98-0.82,2.12-1.46,3.41-1.92 c1.29-0.46,2.68-0.69,4.18-0.69c1.46,0,2.84,0.23,4.14,0.69s2.45,1.1,3.45,1.92s1.78,1.75,2.34,2.81s0.84,2.18,0.84,3.36 c0,1.21-0.28,2.34-0.84,3.39s-1.34,1.98-2.35,2.79c-1.01,0.81-2.16,1.44-3.45,1.88c-1.29,0.45-2.67,0.67-4.15,0.67 s-2.87-0.22-4.15-0.67c-1.29-0.45-2.42-1.07-3.41-1.86c-0.98-0.79-1.75-1.72-2.31-2.78C127.32,128.08,127.04,126.93,127.04,125.71z  M130.5,125.69c0,0.86,0.19,1.67,0.56,2.4c0.38,0.74,0.9,1.39,1.57,1.94c0.67,0.56,1.46,0.99,2.35,1.31 c0.9,0.31,1.85,0.47,2.87,0.47c1.02,0,1.97-0.16,2.84-0.47c0.88-0.31,1.63-0.75,2.28-1.31c0.64-0.56,1.16-1.2,1.53-1.94 c0.38-0.74,0.56-1.53,0.56-2.38c0-0.86-0.19-1.66-0.58-2.4s-0.9-1.39-1.56-1.95c-0.65-0.57-1.42-1.01-2.31-1.32 s-1.84-0.47-2.86-0.47s-1.97,0.16-2.86,0.48s-1.66,0.76-2.32,1.32s-1.18,1.21-1.54,1.96C130.68,124.07,130.5,124.85,130.5,125.69z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M159.06,117.11c1.16,0,2.21,0.13,3.16,0.38s1.77,0.61,2.45,1.07s1.21,1.03,1.57,1.71 c0.37,0.68,0.55,1.46,0.55,2.35c0,0.68-0.13,1.35-0.38,2.02c-0.25,0.68-0.66,1.29-1.23,1.84c-0.57,0.55-1.31,0.99-2.24,1.32 c-0.92,0.33-2.06,0.5-3.4,0.5h-3.06v5.96h-3.38v-17.14L159.06,117.11L159.06,117.11z M159.5,125.64c0.73,0,1.35-0.09,1.85-0.28 s0.9-0.43,1.18-0.73c0.29-0.3,0.5-0.61,0.62-0.95s0.19-0.66,0.19-0.95c0-0.28-0.06-0.59-0.17-0.93s-0.31-0.66-0.59-0.98 s-0.66-0.57-1.14-0.77s-1.09-0.29-1.82-0.29h-3.12v5.89h3V125.64z M163.13,127.31l5.37,6.95h-3.93l-5.45-6.88L163.13,127.31z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M176.75,128.68l-7.76-11.56h4.13l5.91,9.23l-1.04,0.05l5.86-9.28h4.13l-7.88,11.56v5.58h-3.35L176.75,128.68 L176.75,128.68z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M200.99,117.11h3.38v14.51h10.36v2.64H201v-17.15H200.99z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M217.52,125.71c0-1.18,0.28-2.3,0.84-3.36s1.33-2,2.31-2.81c0.98-0.82,2.12-1.46,3.41-1.92 c1.29-0.46,2.68-0.69,4.18-0.69c1.46,0,2.84,0.23,4.14,0.69s2.45,1.1,3.45,1.92s1.78,1.75,2.34,2.81s0.84,2.18,0.84,3.36 c0,1.21-0.28,2.34-0.84,3.39s-1.34,1.98-2.35,2.79c-1.01,0.81-2.16,1.44-3.45,1.88c-1.29,0.45-2.67,0.67-4.15,0.67 s-2.87-0.22-4.15-0.67c-1.29-0.45-2.42-1.07-3.41-1.86c-0.98-0.79-1.75-1.72-2.31-2.78C217.8,128.08,217.52,126.93,217.52,125.71z  M220.99,125.69c0,0.86,0.19,1.67,0.56,2.4c0.38,0.74,0.9,1.39,1.57,1.94c0.67,0.56,1.46,0.99,2.35,1.31 c0.9,0.31,1.85,0.47,2.87,0.47c1.02,0,1.97-0.16,2.84-0.47c0.88-0.31,1.63-0.75,2.28-1.31c0.64-0.56,1.16-1.2,1.53-1.94 c0.38-0.74,0.56-1.53,0.56-2.38c0-0.86-0.19-1.66-0.58-2.4s-0.9-1.39-1.56-1.95c-0.65-0.57-1.42-1.01-2.31-1.32 s-1.84-0.47-2.86-0.47s-1.97,0.16-2.86,0.48s-1.66,0.76-2.32,1.32s-1.18,1.21-1.54,1.96C221.17,124.07,220.99,124.85,220.99,125.69 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M260.35,132.68c-0.31,0.2-0.72,0.41-1.23,0.62c-0.51,0.21-1.1,0.4-1.76,0.56c-0.66,0.17-1.34,0.3-2.04,0.41 c-0.69,0.11-1.34,0.17-1.93,0.17c-1.71,0-3.25-0.21-4.6-0.64c-1.36-0.43-2.51-1.01-3.48-1.75c-0.96-0.75-1.7-1.63-2.22-2.64 s-0.78-2.13-0.78-3.36c0-1.47,0.29-2.78,0.88-3.92c0.59-1.14,1.38-2.1,2.37-2.87c0.99-0.78,2.14-1.36,3.43-1.75 c1.3-0.39,2.67-0.59,4.11-0.59c1.27,0,2.45,0.12,3.53,0.35c1.09,0.23,2.02,0.53,2.81,0.9l-1.12,2.54c-0.37-0.19-0.83-0.36-1.4-0.51 s-1.15-0.27-1.75-0.38c-0.6-0.1-1.14-0.15-1.64-0.15c-1.19,0-2.27,0.14-3.23,0.41c-0.96,0.27-1.78,0.68-2.45,1.21 s-1.19,1.18-1.54,1.94c-0.36,0.76-0.53,1.62-0.53,2.58c0,0.9,0.19,1.7,0.58,2.43c0.39,0.72,0.91,1.34,1.57,1.86 s1.47,0.92,2.41,1.19s1.98,0.41,3.12,0.41c0.65,0,1.29-0.05,1.91-0.14c0.61-0.09,1.14-0.24,1.58-0.45v-2.85H253v-2.66h7.36v7.08 H260.35z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M265.54,117.11h3.38v17.14h-3.38V117.11z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M285.82,120.62c-0.75-0.33-1.55-0.61-2.4-0.83c-0.85-0.23-1.65-0.34-2.42-0.34c-1.04,0-1.86,0.19-2.45,0.56 c-0.6,0.38-0.9,0.9-0.9,1.55c0,0.47,0.21,0.88,0.62,1.24c0.41,0.35,0.95,0.66,1.6,0.92c0.65,0.26,1.35,0.51,2.08,0.74 c0.64,0.19,1.26,0.41,1.88,0.67c0.62,0.26,1.18,0.57,1.69,0.94s0.91,0.84,1.21,1.41c0.3,0.57,0.45,1.26,0.45,2.06 c0,0.91-0.27,1.73-0.82,2.46c-0.55,0.73-1.35,1.32-2.41,1.77s-2.32,0.67-3.78,0.67c-0.89,0-1.75-0.08-2.58-0.24 c-0.84-0.16-1.63-0.37-2.38-0.64s-1.44-0.59-2.08-0.97l1.5-2.12c0.46,0.28,0.99,0.54,1.59,0.78s1.21,0.42,1.83,0.56 s1.23,0.21,1.8,0.21c0.58,0,1.17-0.08,1.78-0.25c0.6-0.17,1.1-0.43,1.49-0.79s0.58-0.85,0.58-1.46c0-0.49-0.17-0.9-0.52-1.24 c-0.34-0.34-0.79-0.64-1.34-0.9s-1.15-0.49-1.8-0.69c-0.64-0.21-1.3-0.43-1.99-0.68s-1.33-0.56-1.92-0.93 c-0.59-0.37-1.05-0.82-1.4-1.36c-0.35-0.53-0.52-1.18-0.52-1.95c0-0.94,0.26-1.76,0.78-2.46s1.26-1.25,2.24-1.66 c0.97-0.41,2.07-0.63,3.3-0.66c1.48,0,2.75,0.15,3.8,0.43c1.05,0.29,1.99,0.65,2.81,1.07L285.82,120.62z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M290.12,117.11h14.05v2.64h-5.43v14.51h-3.35v-14.51h-5.28v-2.64H290.12z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M308.56,117.11h3.38v17.14h-3.38V117.11z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M333.4,132.92c-0.29,0.19-0.74,0.4-1.36,0.65s-1.34,0.46-2.18,0.64s-1.76,0.26-2.78,0.25 c-1.63-0.02-3.1-0.26-4.4-0.72s-2.4-1.09-3.32-1.88c-0.91-0.79-1.62-1.7-2.11-2.73s-0.73-2.13-0.73-3.31 c0-1.27,0.25-2.45,0.75-3.55c0.5-1.09,1.21-2.03,2.13-2.82s2.02-1.41,3.29-1.85c1.27-0.44,2.66-0.66,4.18-0.66 c1.31,0,2.49,0.15,3.54,0.44s1.93,0.62,2.64,1l-1.33,2.57c-0.54-0.33-1.21-0.64-2.02-0.93s-1.72-0.43-2.74-0.43 c-0.92,0-1.8,0.15-2.64,0.46c-0.84,0.31-1.58,0.74-2.22,1.3c-0.64,0.56-1.16,1.21-1.53,1.95c-0.38,0.75-0.56,1.54-0.56,2.39 c0,0.88,0.17,1.7,0.51,2.46c0.34,0.76,0.82,1.42,1.44,1.97s1.37,0.98,2.23,1.27c0.87,0.3,1.85,0.45,2.94,0.45 c1.1,0,2.05-0.14,2.87-0.41c0.82-0.28,1.48-0.59,1.98-0.93L333.4,132.92z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M349.01,120.62c-0.75-0.33-1.55-0.61-2.4-0.83c-0.85-0.23-1.65-0.34-2.42-0.34c-1.04,0-1.86,0.19-2.45,0.56 c-0.6,0.38-0.9,0.9-0.9,1.55c0,0.47,0.21,0.88,0.62,1.24c0.41,0.35,0.95,0.66,1.6,0.92c0.65,0.26,1.35,0.51,2.08,0.74 c0.64,0.19,1.26,0.41,1.88,0.67c0.62,0.26,1.18,0.57,1.69,0.94s0.91,0.84,1.21,1.41c0.3,0.57,0.45,1.26,0.45,2.06 c0,0.91-0.27,1.73-0.82,2.46c-0.55,0.73-1.35,1.32-2.41,1.77s-2.32,0.67-3.78,0.67c-0.89,0-1.75-0.08-2.58-0.24 c-0.84-0.16-1.63-0.37-2.38-0.64s-1.44-0.59-2.08-0.97l1.5-2.12c0.46,0.28,0.99,0.54,1.59,0.78s1.21,0.42,1.83,0.56 s1.23,0.21,1.8,0.21c0.58,0,1.17-0.08,1.78-0.25c0.6-0.17,1.1-0.43,1.49-0.79s0.58-0.85,0.58-1.46c0-0.49-0.17-0.9-0.52-1.24 c-0.34-0.34-0.79-0.64-1.34-0.9s-1.15-0.49-1.8-0.69c-0.64-0.21-1.3-0.43-1.99-0.68s-1.33-0.56-1.92-0.93 c-0.59-0.37-1.05-0.82-1.4-1.36c-0.35-0.53-0.52-1.18-0.52-1.95c0-0.94,0.26-1.76,0.78-2.46s1.26-1.25,2.24-1.66 c0.97-0.41,2.07-0.63,3.3-0.66c1.48,0,2.75,0.15,3.8,0.43c1.05,0.29,1.99,0.65,2.81,1.07L349.01,120.62z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M364.25,134.26V116.5h0.03l11.31,13.07l-1.44-0.26l11.25-12.81h0.06v17.76h-3.35V122.7l0.2,1.39l-7.59,8.78 h-0.06l-7.73-8.78l0.58-1.27v11.44H364.25z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M389.12,134.26l9.32-17.85h0.2l9.29,17.85h-3.84l-6.58-13.57l2.42-1.29l-7.5,14.86H389.12z M395.01,127.9h7.16 l1.15,2.31h-9.35L395.01,127.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M430.09,134.87l-16.13-12.76l1.01,0.33l0.06,11.82h-3.4v-17.73h0.17l15.84,12.76l-0.75-0.19l-0.06-11.99h3.35 v17.76H430.09z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M433.87,134.26l9.32-17.85h0.2l9.29,17.85h-3.84l-6.58-13.57l2.42-1.29l-7.5,14.86H433.87z M439.76,127.9h7.16 l1.15,2.31h-9.35L439.76,127.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M472.31,132.68c-0.31,0.2-0.72,0.41-1.23,0.62c-0.51,0.21-1.1,0.4-1.76,0.56c-0.66,0.17-1.34,0.3-2.04,0.41 c-0.69,0.11-1.34,0.17-1.93,0.17c-1.71,0-3.25-0.21-4.6-0.64c-1.36-0.43-2.51-1.01-3.48-1.75c-0.96-0.75-1.7-1.63-2.22-2.64 s-0.78-2.13-0.78-3.36c0-1.47,0.29-2.78,0.88-3.92s1.38-2.1,2.37-2.87c0.99-0.78,2.14-1.36,3.43-1.75c1.3-0.39,2.67-0.59,4.11-0.59 c1.27,0,2.45,0.12,3.53,0.35c1.09,0.23,2.02,0.53,2.81,0.9l-1.12,2.54c-0.37-0.19-0.83-0.36-1.4-0.51s-1.15-0.27-1.75-0.38 c-0.6-0.1-1.14-0.15-1.64-0.15c-1.19,0-2.27,0.14-3.23,0.41c-0.96,0.27-1.78,0.68-2.45,1.21s-1.19,1.18-1.54,1.94 c-0.36,0.76-0.53,1.62-0.53,2.58c0,0.9,0.19,1.7,0.58,2.43c0.39,0.72,0.91,1.34,1.57,1.86s1.47,0.92,2.41,1.19s1.98,0.41,3.12,0.41 c0.65,0,1.29-0.05,1.91-0.14c0.61-0.09,1.14-0.24,1.58-0.45v-2.85h-3.95v-2.66h7.36L472.31,132.68L472.31,132.68z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M477.5,117.11h13.94v2.64h-10.56v4.57h9.41v2.64h-9.41v4.66h10.96v2.64H477.5V117.11z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M496.6,134.26V116.5h0.03l11.31,13.07l-1.44-0.26l11.25-12.81h0.06v17.76h-3.35V122.7l0.2,1.39l-7.59,8.78 h-0.06l-7.73-8.78l0.58-1.27v11.44H496.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M523.7,117.11h13.94v2.64h-10.56v4.57h9.41v2.64h-9.41v4.66h10.96v2.64H523.7V117.11z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M561.27,134.87l-16.13-12.76l1.01,0.33l0.06,11.82h-3.4v-17.73h0.17l15.84,12.76l-0.75-0.19L558,117.11h3.35 v17.76H561.27z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M565.77,117.11h14.05v2.64h-5.43v14.51h-3.35v-14.51h-5.28v-2.64H565.77z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpproLogo600PxAnglaisWhite);
export default __webpack_public_path__ + "static/media/exppro-logo-600px-anglais-white.273f063999943abbd21b334f47dada72.svg";
export { ForwardRef as ReactComponent };